import reducer from 'state/mrCollection/quote/reducer';
import actions from 'state/mrCollection/quote/actionCreators';
import selectors from 'state/mrCollection/quote/selectors';

export { actions, selectors };

export default reducer;
